import { createAction, props } from '@ngrx/store';

import { DataLayerMapConfig, MapRegionConfig } from '@core/api';
import { apiActionFactory } from '@core/store';

export const exportPlans = createAction('[Map/Header] Export Plans');

export const openPrintingPanel = createAction('[Map/Header] Open Printing Panel');

export const openReportsPage = createAction('[Map/Header] Open Reports Page');

export const openShareDialog = createAction('[Map/Header] Open Share Dialog');

export const startMeasure = createAction('[Map/Header] Start Measure', props<{ mode: 'distance' | 'area' }>());

export const openNatureReportingPage = createAction('[Map/Header] Open Nature Reporting Page');

export const openEditMapDialog = createAction(
  '[Map/Header] Open Edit Map Dialog',
  props<{ mapId: string; mapName: string; regionConfig: MapRegionConfig }>()
);
export const renameMap = createAction('[Map/Header/Dialog] Rename Map', props<{ id: string; name: string }>());
export const [renameMapSuccess, renameMapFail] = apiActionFactory<{ id: string; name: string; updatedAt: string; version: string }>(
  '[Map/Header/Dialog/API] Rename Map'
);
export const updateSubregions = createAction('[Map/Header/Dialog] Update Subregions', props<{ id: string; subregions: string[] }>());
export const [updateSubregionsSuccess, updateSubregionsFail] = apiActionFactory<{
  id: string;
  subregions: string[];
  updatedAt: string;
  regionConfig: MapRegionConfig;
  dataLayers: DataLayerMapConfig[];
  version: string;
}>('[Map/Header/Dialog/API] Update Subregions');
